module.exports = __webpack_public_path__ + "img/DANA.5ad36418.svg";